module.exports = __webpack_public_path__ + "static/img/img-5.266125da.png";